import { bunja } from 'bunja';
import { atom } from 'jotai';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { spotFormBunja } from './form';

export const spotFormSegmentDataBunja = bunja(() => {
  const { orderStateAtom, priceTypeAtom } = bunja.use(spotFormBunja);
  const { symbol } = bunja.use(tradeSymbolBunja);

  type OrderByToken = 'margin' | 'quantity' | 'position_size';
  const orderByTokenAtom = atom<OrderByToken>((get) => {
    const state = get(orderStateAtom);
    return state.type === 'quantity' ? 'quantity' : 'position_size';
  });

  type OrderType = 'market_order' | 'trigger_price_order' | 'trigger_time_order' | 'limit_order';
  const orderTypeAtom = atom<OrderType>((get) => {
    const priceType = get(priceTypeAtom);
    return priceType === 'market' ? 'market_order' : priceType === 'limit' ? 'limit_order' : 'trigger_price_order';
  });

  return {
    symbol,
    orderByTokenAtom,
    orderTypeAtom,
  };
});
spotFormSegmentDataBunja.debugLabel = 'spotFormSegmentDataBunja';
